import Header from "../components/Header";
import DashboardPreview from "../components/imageComponent";
import StatsSection from "../components/statsSection";
import Footer from "../components/Footer";
import React, { useEffect, useRef, useState } from 'react';
import BookDemo from "../components/BookDemo";
import ERPIntegration from "../components/ERPIntegration";
import { setSelectionRange } from "@testing-library/user-event/dist/utils";
import { Link } from 'react-router-dom';
import AdeyaVideo from "../components/AdeyaVideo";

export default function Home() {
  const statsRef = useRef(null);
  const [showBookDemo, setshowBookDemo] = useState(false)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          // Stats animation trigger
        }
      },
      { threshold: 0.3 }
    );
    if (statsRef.current) observer.observe(statsRef.current);
    return () => observer.disconnect();
  }, []);

  // const features = [
  //   { icon: '📦', title: 'Smart Inventory', desc: 'AI-powered stock predictions & auto-reordering' },
  //   { icon: '📊', title: 'Real-time Analytics', desc: 'Live dashboards with actionable insights' },
  //   { icon: '🤝', title: 'Vendor Management', desc: 'Streamlined procurement & payment tracking' },
  //   { icon: '💰', title: 'Financial Insights', desc: 'Profit/Loss reports & tax calculations' },
  //   { icon: '🔒', title: 'Bank-grade Security', desc: '256-bit encryption & role-based access' },
  //   { icon: '📱', title: 'Mobile Ready', desc: 'Access anywhere, anytime on any device' }
  // ];

  return (
    <>
      <Header />
      <div className="bg-white font-sans text-slate-900 overflow-x-hidden">

        {/* Hero Section - Centered Perfectly */}
        <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="rounded-full blur-3xl opacity-30 animate-pulse"></div>
            <div className="  rounded-full blur-3xl opacity-30 animate-pulse delay-1000"></div>
          </div>

          <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10 py-20">
            <div className="animate-fade-in-up">
              <span className="inline-flex items-center gap-2 px-4 py-2 mb-6 text-xs sm:text-sm font-semibold tracking-wide text-blue-700 uppercase bg-blue-100 rounded-full">
                <span className="w-2 h-2 bg-blue-800 rounded-full animate-ping"></span>
                INVENTORY DECISION PLATFORM
              </span>
              <h1 className="max-w-5xl mx-auto mb-6 text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-extrabold tracking-tight">
                Make Smarter

                <span className="text-sky-500">
                  {" "}Inventory Decisions.
                </span>
              </h1>
              <p className="max-w-2xl mx-auto mb-8 sm:mb-10 text-base sm:text-lg md:text-xl text-slate-600 leading-relaxed px-4">
                Adeya brings your inventory, sales and purchase data together
                to give your team clear insights and help make better
                inventory decisions.
              </p>
              <div className="flex flex-col sm:flex-row justify-center gap-4 mb-12 sm:mb-16">
                <Link to="/contact">
                  <button className="group px-6 sm:px-8 py-3 sm:py-4 bg-sky-500/100 text-white font-bold rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
                    Contact Us
                  </button>
                </Link>
                <button
                  onClick={() => setshowBookDemo(true)}
                  className="px-6 sm:px-8 py-3 sm:py-4 bg-white text-blue-700 font-bold rounded-xl shadow-lg border-2 border-blue-200 hover:border-blue-600 transition-all duration-300">
                  Book Demo
                </button>
              </div>
            </div>
          </div>
        </section>

        {/* Trusted By Marquee - Fixed Overflow */}
        <div className="py-4 bg-slate-900 text-white overflow-hidden w-full">
          <div className="flex animate-marquee whitespace-nowrap">
            {[...Array(2)].map((_, i) => (
              <div key={i} className="flex items-center gap-8 sm:gap-12 mx-6 sm:mx-8">
                {/* <span className="text-xs sm:text-sm font-semibold uppercase tracking-wider">🏢 5000+ Businesses</span>
                <span className="text-xs sm:text-sm font-semibold uppercase tracking-wider">🚀 5+ Countries</span>
                <span className="text-xs sm:text-sm font-semibold uppercase tracking-wider">🏭 99.9% Uptime</span>
                <span className="text-xs sm:text-sm font-semibold uppercase tracking-wider">📦 Trusted Worldwide</span> */}
                <span className="text-xs sm:text-sm font-semibold uppercase tracking-wider">
                  📊 Inventory Visibility
                </span>

                <span className="text-xs sm:text-sm font-semibold uppercase tracking-wider">
                  📦 Smarter Stock Decisions
                </span>

                <span className="text-xs sm:text-sm font-semibold uppercase tracking-wider">
                  📈 Sales & Purchase Insights
                </span>

                <span className="text-xs sm:text-sm font-semibold uppercase tracking-wider">
                  ⚡ Real-Time Inventory Insights
                </span>

              </div>
            ))}
          </div>
        </div>
        <AdeyaVideo />

        {/* Dashboard Preview Section - No extra spacing issues */}
        <DashboardPreview />
        <ERPIntegration/>

        {/* Features Section - Grid Perfect Alignment */}
        {/* <section className="py-16 sm:py-20 md:py-32 bg-white">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12 sm:mb-16">
              <span className="text-blue-600 font-bold uppercase tracking-wider text-xs sm:text-sm">Why Choose Adeya IMS</span>
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mt-2 mb-4 px-4">Everything You Need to Scale</h2>
              <p className="text-base sm:text-lg md:text-xl text-slate-600 max-w-2xl mx-auto px-4">Powerful features designed to streamline your entire business operations</p>
            </div>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
              {features.map((feature, idx) => (
                <div 
                  key={idx}
                  className="group p-6 sm:p-8 rounded-2xl bg-gradient-to-br from-white to-slate-50 border border-slate-200 hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 cursor-pointer"
                >
                  <div className="text-4xl sm:text-5xl mb-4 group-hover:scale-110 transition-transform duration-300">{feature.icon}</div>
                  <h3 className="text-lg sm:text-xl font-bold mb-3 group-hover:text-blue-600 transition">{feature.title}</h3>
                  <p className="text-slate-600 text-sm sm:text-base leading-relaxed">{feature.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section> */}

        {/* Stats Section */}
        <StatsSection ref={statsRef} />

        <section className="py-10 sm:py-28 bg-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <div className="border-t-2 border-slate-100 pt-16 sm:pt-20">
              <div className="inline-flex items-center gap-2 px-4 py-1 mb-6 text-sm font-semibold text-green-700 uppercase bg-green-100 rounded-full">
                {/* 🎉 Join 5,000+ happy customers */}
                📊 MAKE BETTER INVENTORY DECISIONS
              </div>
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-slate-900 mb-4">
                {/* Ready to optimize your inventory? */}
                Ready to take control of your inventory?
              </h2>
              <p className="text-lg sm:text-xl text-slate-600 mb-8 max-w-2xl mx-auto">
                {/* Start managing your purchases, sales, and inventory like a pro. */}
                Get clearer insights into your inventory, sales and purchases
                and make decisions with greater confidence.
              </p>
              <div className="flex flex-col sm:flex-row justify-center gap-4">
                <button className="px-8 sm:px-10 py-4 bg-slate-900 text-white font-bold rounded-xl shadow-lg hover:shadow-2xl hover:bg-slate-800 transition-all duration-300 text-lg">
                  Learn More
                </button>
                <Link to="/contact">
                  <button className="px-8 sm:px-10 py-4 bg-white text-slate-700 font-bold rounded-xl shadow-lg border-2 border-slate-200 hover:border-slate-900 transition-all duration-300 text-lg">
                    Talk to Expert 💬
                  </button>
                </Link>
              </div>
              <div className="mt-8 flex flex-wrap justify-center gap-4 text-sm text-slate-400">
                <span>✓ Easy setup in 10 minutes</span>
                <span>✓ Better Stock Decisions</span>
                <span>✓ 24/7 Priority Support</span>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>

      {showBookDemo && (
        <BookDemo onClose={() => setshowBookDemo(false)} />
      )}

      <style jsx>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .animate-fade-in-up {
          animation: fadeInUp 0.8s ease-out;
        }
        
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        
        .animate-marquee {
          animation: marquee 25s linear infinite;
        }
      `}</style>
    </>
  );
}